import { IconProps } from "../../../types/style";

const BigCarSpeed = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00012 7H5.50012C4.95012 7 4.50012 6.55 4.50012 6V1H9.00012C9.75012 1 10.4051 1.41499 10.7451 2.02499"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 8.5C11 9.33 10.33 10 9.5 10H9C9 9.45 8.55 9 8 9C7.45 9 7 9.45 7 10H5C5 9.45 4.55 9 4 9C3.45 9 3 9.45 3 10H2.5C1.67 10 1 9.33 1 8.5V7H2.5C2.775 7 3 6.775 3 6.5V5C3 4.725 2.775 4.5 2.5 4.5H1.85501L2.70999 3.005C2.88999 2.695 3.21999 2.5 3.57999 2.5H4.5V6C4.5 6.55 4.95 7 5.5 7H6"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 11C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9C4.55228 9 5 9.44772 5 10C5 10.5523 4.55228 11 4 11Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 6V7H2.5C2.775 7 3 6.775 3 6.5V5C3 4.725 2.775 4.5 2.5 4.5H1.85501L1 6Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 4H8"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 5.5H9"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 7H10"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default BigCarSpeed;
